// Top-level router. All authed routes nest under the Layout so the
// header + WS subscriber stay mounted across navigations.

import { Navigate, Route, Routes } from "react-router-dom";

import { Layout } from "./components/Layout";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { CaseDetailPage } from "./pages/CaseDetailPage";
import { CaseListPage } from "./pages/CaseListPage";
import { DashboardPage } from "./pages/DashboardPage";
import { DeadlinesPage } from "./pages/DeadlinesPage";
import { DocumentDetailPage } from "./pages/DocumentDetailPage";
import { DraftDetailPage } from "./pages/DraftDetailPage";
import { DraftNewPage } from "./pages/DraftNewPage";
import { LoginPage } from "./pages/LoginPage";
import { PreAuthDraftDetailPage } from "./pages/PreAuthDraftDetailPage";
import { PreAuthNewPage } from "./pages/PreAuthNewPage";
import { SettingsPage } from "./pages/SettingsPage";
import { StatutesPage } from "./pages/StatutesPage";

export function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/cases" element={<CaseListPage />} />
        <Route path="/deadlines" element={<DeadlinesPage />} />
        <Route path="/cases/:caseId" element={<CaseDetailPage />} />
        <Route path="/cases/:caseId/drafts/new" element={<DraftNewPage />} />
        <Route path="/cases/:caseId/preauth/new" element={<PreAuthNewPage />} />
        <Route path="/drafts/:draftId" element={<DraftDetailPage />} />
        <Route path="/preauth-drafts/:draftId" element={<PreAuthDraftDetailPage />} />
        <Route path="/documents/:documentId" element={<DocumentDetailPage />} />
        <Route path="/statutes" element={<StatutesPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
